import React, { Component } from 'react';
import { Modal, Form, FormField, Input, Button } from '$common';

export default class PasswordModal extends Component {
  render() {
    const { isOpen, onSubmit } = this.props;

    const content = (
      <div style={{ textAlign: 'center' }}>
        <Form onSubmit={onSubmit}>
          <FormField name="password" label="To continue please enter your current password">
            <Input name="password" type="password" />
          </FormField>
          <Button type="success" block submit>Continue</Button>
        </Form>
      </div>
    )

    return (
      <Modal
        isOpen={isOpen}
        closeable={false}
        content={content}
        title="Enter you password"
        size="small"
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/root/password-modal.js